/**
 * Site-wide defaults.
 *
 * IMPORTANT: No brand values are hardcoded here on purpose.
 * Every branding value (site name, tagline, logo, favicon, phone, emails)
 * is configured at runtime from Developer Settings -> Branding / General
 * and served by GET /api/settings/site.
 *
 * These constants exist only as safe empty fallbacks so the UI can decide
 * to render nothing instead of a wrong brand.
 */
export const DEFAULT_SITE_NAME = '';
export const DEFAULT_LOGO_URL = '';
export const DEFAULT_SUPPORT_EMAIL = '';

export const buildSiteSettingsState = (payload = {}, loading = false) => ({
  siteName: payload.site_name || DEFAULT_SITE_NAME,
  siteTagline: payload.site_tagline || '',
  siteUrl: payload.site_url || '',
  logoUrl: payload.logo_url || DEFAULT_LOGO_URL,
  logoDarkUrl: payload.logo_dark_url || '',
  faviconUrl: payload.favicon_url || '',
  chatbotIconUrl: payload.chatbot_icon_url || '',
  adminEmail: payload.admin_email || '',
  supportEmail: payload.support_email || DEFAULT_SUPPORT_EMAIL,
  sitePhone: payload.site_phone || '',
  siteAddress: payload.site_address || '',
  facebookUrl: payload.facebook_url || '',
  instagramUrl: payload.instagram_url || '',
  maintenanceMode: Boolean(payload.maintenance_mode),
  debugMode: Boolean(payload.debug_mode),
  requireAccountForCheckout: Boolean(payload.require_account_for_checkout),
  requireEmailVerificationForRegistration: payload.require_email_verification_for_registration !== false,
  loading,
});
